import ATE from "../../../ActionTypeEnum";
import {jobInitialState} from "../../../initial-state";
import IJobState from "../interfaces/IJobState";

function reduce(
        state: IJobState = jobInitialState,
        action: {type: ATE, value?: any}
    ): IJobState {

    switch (action.type) {

        case ATE.JOB_INFO_REQUEST: {
            const clear: boolean = action.value;
            if (clear) {
                return {
                    ...jobInitialState,
                    fetching: true,
                };
            } else {
                return {
                    ...state,
                    fetching: true,
                };
            }
        }
        case ATE.JOB_INFO_NON_EXIST:
            return {
                ...state,
                fetching: false,
                fetchNotFound: true,
            };
        case ATE.JOB_INFO_FAILURE:
            return {
                ...state,
                fetching: false,
                fetchFailed: true,
            };

        case ATE.JOB_INFO_SUCCESS:
            return {
                ...state,
                fetching: false,
                jobInfo: action.value,
            };

        case ATE.JOB_GET_INPUT_REQUEST:
            return {
                ...state,
                inputFileFetching: true,
                inputFileFetchFailed: false,
                inputFileSucceed: false,
            };
        case ATE.JOB_GET_INPUT_FAILURE:
            return {
                ...state,
                inputFileFetching: false,
                inputFileFetchFailed: true,
            };
        case ATE.JOB_GET_INPUT_SUCCESS:
            return {
                ...state,
                inputFileFetching: false,
                inputFileSucceed: true,
            };

        case ATE.JOB_RERUN_REQUEST:
            return {
                ...state,
                rerunFetching: true,
                rerunFetchFailed: false,
                rerunSuccess: false,
            };
        case ATE.JOB_RERUN_FAILURE:
            return {
                ...state,
                rerunFetching: false,
                rerunFetchFailed: true,
            };
        case ATE.JOB_RERUN_SUCCESS:
            return {
                ...state,
                rerunFetching: false,
                rerunSuccess: true,
            };

        default:
            return state;

    }

}

export default function reduceWrapper(
        state: IJobState = jobInitialState,
        action: {type: ATE, value?: any}
): IJobState {
    return reduce(state, action);
}
